import React from "react";
import { Box, Typography } from "@mui/material";
import Breadcrumb from "../../components/common/breadcrumb/Breadcrumb";

const breadcrumb = ["Packages Arrived"];

const PackagesArrived = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Breadcrumb pageNameList={breadcrumb} />
      <Typography variant="subtitle2">Packages Arrived</Typography>
    </Box>
  );
};

export default PackagesArrived;
